const constants = {
  GAME_LENGTH: 25
};

export default constants;
